// import React, { useState } from 'react';
// import { UserPlus, Users, Mail, Phone, Shield, Plus, Edit, Trash2, Search, X, Save, Eye, EyeOff, ShoppingBag, IdCard, Calendar } from 'lucide-react';

// const VendorManagement = () => {
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [selectedVendor, setSelectedVendor] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [showPassword, setShowPassword] = useState(false);

//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     phone: '',
//     cin: '',
//     address: '',
//     birthDate: '',
//     hireDate: '',
//     password: '',
//     status: 'active'
//   });

//   // Liste des vendeurs
//   const vendors = [
//     {
//       id: 1,
//       firstName: 'Moussa',
//       lastName: 'Sow',
//       email: 'm.sow@pharmacie.sn',
//       phone: '+221 77 111 22 33',
//       cin: '2845 1998 12345',
//       address: 'Liberté 6, Dakar',
//       birthDate: '1998-05-15',
//       hireDate: '2023-01-15',
//       status: 'active',
//       createdAt: '2023-01-15'
//     },
//     {
//       id: 2,
//       firstName: 'Awa',
//       lastName: 'Diallo',
//       email: 'a.diallo@pharmacie.sn',
//       phone: '+221 77 222 33 44',
//       cin: '1923 1995 67890',
//       address: 'Médina, Dakar',
//       birthDate: '1995-08-20',
//       hireDate: '2023-03-01',
//       status: 'active',
//       createdAt: '2023-03-01'
//     },
//     {
//       id: 3,
//       firstName: 'Ibrahima',
//       lastName: 'Niang',
//       email: 'i.niang@pharmacie.sn',
//       phone: '+221 77 333 44 55',
//       cin: '1567 1997 11111',
//       address: 'Grand Yoff, Dakar',
//       birthDate: '1997-12-10',
//       hireDate: '2023-06-15',
//       status: 'inactive',
//       createdAt: '2023-06-15'
//     },
//     {
//       id: 4,
//       firstName: 'Fatou',
//       lastName: 'Cissé',
//       email: 'f.cisse@pharmacie.sn',
//       phone: '+221 77 444 55 66',
//       cin: '2234 1999 22222',
//       address: 'Parcelles Assainies, Dakar',
//       birthDate: '1999-03-25',
//       hireDate: '2024-01-10',
//       status: 'active',
//       createdAt: '2024-01-10'
//     }
//   ];

//   const filteredVendors = vendors.filter(vendor =>
//     vendor.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     vendor.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     vendor.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     vendor.phone.includes(searchTerm) ||
//     vendor.cin.includes(searchTerm)
//   );

//   const stats = {
//     total: vendors.length,
//     active: vendors.filter(v => v.status === 'active').length,
//     inactive: vendors.filter(v => v.status === 'inactive').length
//   };

//   const getStatusBadge = (status) => {
//     return status === 'active'
//       ? { bg: 'bg-emerald-100', text: 'text-emerald-700', label: 'Actif', border: 'border-emerald-200' }
//       : { bg: 'bg-gray-100', text: 'text-gray-700', label: 'Inactif', border: 'border-gray-200' };
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value
//     });
//   };

//   const openAddModal = () => {
//     setFormData({
//       firstName: '',
//       lastName: '',
//       email: '',
//       phone: '',
//       cin: '',
//       address: '',
//       birthDate: '',
//       hireDate: new Date().toISOString().split('T')[0],
//       password: '',
//       status: 'active'
//     });
//     setShowAddModal(true);
//   };

//   const openEditModal = (vendor) => {
//     setSelectedVendor(vendor);
//     setFormData({
//       firstName: vendor.firstName,
//       lastName: vendor.lastName,
//       email: vendor.email,
//       phone: vendor.phone,
//       cin: vendor.cin,
//       address: vendor.address,
//       birthDate: vendor.birthDate,
//       hireDate: vendor.hireDate,
//       password: '',
//       status: vendor.status
//     });
//     setShowEditModal(true);
//   };

//   const closeModals = () => {
//     setShowAddModal(false);
//     setShowEditModal(false);
//     setSelectedVendor(null);
//     setShowPassword(false);
//   };

//   const handleSubmit = () => {
//     if (showEditModal) {
//       alert('Vendeur modifié avec succès !');
//     } else {
//       alert('Vendeur créé avec succès !');
//     }
//     closeModals();
//   };

//   const handleDelete = (id) => {
//     if (window.confirm('Êtes-vous sûr de vouloir supprimer ce vendeur ?')) {
//       alert('Vendeur supprimé avec succès !');
//     }
//   };

//   const toggleStatus = (vendor) => {
//     const newStatus = vendor.status === 'active' ? 'inactive' : 'active';
//     if (window.confirm(`Voulez-vous ${newStatus === 'active' ? 'activer' : 'désactiver'} ce vendeur ?`)) {
//       alert(`Vendeur ${newStatus === 'active' ? 'activé' : 'désactivé'} avec succès !`);
//     }
//   };

//   const formatDate = (dateString) => {
//     return new Date(dateString).toLocaleDateString('fr-FR', { 
//       day: '2-digit', 
//       month: 'long', 
//       year: 'numeric' 
//     });
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
//       <div className="fixed inset-0 overflow-hidden pointer-events-none opacity-30">
//         <div className="absolute inset-0" style={{
//           backgroundImage: `radial-gradient(circle at 2px 2px, rgb(209, 213, 219) 1px, transparent 0)`,
//           backgroundSize: '40px 40px'
//         }}></div>
//       </div>

//       <main className="relative z-10 p-4 md:p-8">
//         {/* Header */}
//         <div className="mb-8">
//           <h1 className="text-4xl md:text-4xl font-black text-gray-800 mb-4">
//             Gestion des Vendeurs
//           </h1>
//           <p className="text-gray-600 text-lg">Créez et gérez les comptes de vos vendeurs</p>
//         </div>

//         {/* Stats */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
//           <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-200">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm text-gray-600 mb-1">Total vendeurs</p>
//                 <p className="text-4xl font-black text-gray-800">{stats.total}</p>
//               </div>
//               <div className="w-14 h-14 bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl flex items-center justify-center shadow-md">
//                 <Users className="text-white" size={28} />
//               </div>
//             </div>
//           </div>

//           <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-200">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm text-gray-600 mb-1">Actifs</p>
//                 <p className="text-4xl font-black text-emerald-600">{stats.active}</p>
//               </div>
//               <div className="w-14 h-14 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-xl flex items-center justify-center shadow-md">
//                 <ShoppingBag className="text-white" size={28} />
//               </div>
//             </div>
//           </div>

//           <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-200">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-sm text-gray-600 mb-1">Inactifs</p>
//                 <p className="text-4xl font-black text-gray-600">{stats.inactive}</p>
//               </div>
//               <div className="w-14 h-14 bg-gradient-to-br from-gray-400 to-gray-500 rounded-xl flex items-center justify-center shadow-md">
//                 <Users className="text-white" size={28} />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Search and Add */}
//         <div className="bg-white rounded-2xl shadow-lg p-6 mb-8 border border-gray-200">
//           <div className="flex flex-col md:flex-row gap-4">
//             <div className="flex-1">
//               <div className="relative">
//                 <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
//                 <input
//                   type="text"
//                   placeholder="Rechercher un vendeur (nom, email, téléphone, CIN)..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500"
//                 />
//               </div>
//             </div>
//             <button
//               onClick={openAddModal}
//               className="flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded-xl hover:shadow-xl transition-all font-bold whitespace-nowrap"
//             >
//               <Plus size={20} />
//               <span>Nouveau vendeur</span>
//             </button>
//           </div>
//         </div>

//         {/* Vendors Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {filteredVendors.map((vendor) => {
//             const statusBadge = getStatusBadge(vendor.status);

//             return (
//               <div key={vendor.id} className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all border border-gray-200 overflow-hidden">
//                 <div className="bg-gradient-to-r from-purple-500 to-purple-600 p-6">
//                   <div className="flex items-start justify-between mb-4">
//                     <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center">
//                       <ShoppingBag className="text-white" size={32} />
//                     </div>
//                     <span className={`px-3 py-1.5 ${statusBadge.bg} ${statusBadge.text} rounded-full text-xs font-bold border ${statusBadge.border}`}>
//                       {statusBadge.label}
//                     </span>
//                   </div>
//                   <h3 className="font-black text-white text-xl mb-1">
//                     {vendor.firstName} {vendor.lastName}
//                   </h3>
//                   <p className="text-purple-100 text-sm">Vendeur</p>
//                 </div>

//                 <div className="p-6 space-y-3">
//                   <div className="flex items-center space-x-3">
//                     <Mail size={18} className="text-gray-400 flex-shrink-0" />
//                     <a href={`mailto:${vendor.email}`} className="text-gray-700 text-sm hover:text-purple-600 transition-colors truncate">
//                       {vendor.email}
//                     </a>
//                   </div>

//                   <div className="flex items-center space-x-3">
//                     <Phone size={18} className="text-gray-400 flex-shrink-0" />
//                     <a href={`tel:${vendor.phone}`} className="text-gray-700 text-sm hover:text-purple-600 transition-colors">
//                       {vendor.phone}
//                     </a>
//                   </div>

//                   <div className="flex items-center space-x-3">
//                     <IdCard size={18} className="text-gray-400 flex-shrink-0" />
//                     <span className="text-gray-700 text-sm font-mono">{vendor.cin}</span>
//                   </div>

//                   <div className="flex items-center space-x-3">
//                     <Calendar size={18} className="text-gray-400 flex-shrink-0" />
//                     <span className="text-gray-700 text-sm">Embauché le {formatDate(vendor.hireDate)}</span>
//                   </div>

//                   <div className="pt-3 border-t border-gray-200 flex space-x-2">
//                     <button
//                       onClick={() => openEditModal(vendor)}
//                       className="flex-1 px-4 py-2 bg-green-50 text-green-600 rounded-xl hover:bg-green-100 transition-all font-semibold text-sm flex items-center justify-center"
//                     >
//                       <Edit size={16} className="mr-2" />
//                       Modifier
//                     </button>
                    
//                     <button
//                       onClick={() => toggleStatus(vendor)}
//                       className={`flex-1 px-4 py-2 rounded-xl transition-all font-semibold text-sm ${
//                         vendor.status === 'active'
//                           ? 'bg-orange-50 text-orange-600 hover:bg-orange-100'
//                           : 'bg-emerald-50 text-emerald-600 hover:bg-emerald-100'
//                       }`}
//                     >
//                       {vendor.status === 'active' ? 'Désactiver' : 'Activer'}
//                     </button>

//                     <button
//                       onClick={() => handleDelete(vendor.id)}
//                       className="px-4 py-2 bg-red-50 text-red-600 rounded-xl hover:bg-red-100 transition-all"
//                     >
//                       <Trash2 size={16} />
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//         </div>

//         {filteredVendors.length === 0 && (
//           <div className="text-center py-12 bg-white rounded-2xl shadow-lg border border-gray-200">
//             <Users size={64} className="mx-auto text-gray-300 mb-4" />
//             <p className="text-gray-500 text-lg font-semibold">Aucun vendeur trouvé</p>
//             <p className="text-gray-400 text-sm mt-2">Essayez de modifier votre recherche</p>
//           </div>
//         )}
//       </main>

//       {/* Add/Edit Modal */}
//       {(showAddModal || showEditModal) && (
//         <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-3xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto border border-gray-200">
//             <div className="sticky top-0 bg-gradient-to-r from-purple-600 to-purple-700 px-6 py-4 flex items-center justify-between z-10 rounded-t-3xl">
//               <h2 className="text-2xl font-black text-white">
//                 {showEditModal ? '✏️ Modifier le vendeur' : '➕ Nouveau vendeur'}
//               </h2>
//               <button onClick={closeModals} className="p-2 hover:bg-white/20 rounded-xl transition-all text-white">
//                 <X size={24} />
//               </button>
//             </div>

//             <div className="p-6">
//               <div className="space-y-6">
//                 {/* Personal Info */}
//                 <div>
//                   <h3 className="font-bold text-gray-800 mb-4 flex items-center">
//                     <Users size={20} className="mr-2" />
//                     Informations personnelles
//                   </h3>
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                     <div>
//                       <label className="block text-sm font-bold text-gray-700 mb-2">Prénom *</label>
//                       <input
//                         type="text"
//                         name="firstName"
//                         value={formData.firstName}
//                         onChange={handleInputChange}
//                         className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500"
//                         placeholder="Prénom"
//                       />
//                     </div>

//                     <div>
//                       <label className="block text-sm font-bold text-gray-700 mb-2">Nom *</label>
//                       <input
//                         type="text"
//                         name="lastName"
//                         value={formData.lastName}
//                         onChange={handleInputChange}
//                         className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500"
//                         placeholder="Nom"
//                       />
//                     </div>

//                     <div>
//                       <label className="block text-sm font-bold text-gray-700 mb-2">Date de naissance *</label>
//                       <input
//                         type="date"
//                         name="birthDate"
//                         value={formData.birthDate}
//                         onChange={handleInputChange}
//                         className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500"
//                       />
//                     </div>

//                     <div>
//                       <label className="block text-sm font-bold text-gray-700 mb-2">CIN *</label>
//                       <input
//                         type="text"
//                         name="cin"
//                         value={formData.cin}
//                         onChange={handleInputChange}
//                         className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500"
//                         placeholder="1234 1990 12345"
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 {/* Contact Info */}
//                 <div>
//                   <h3 className="font-bold text-gray-800 mb-4 flex items-center">
//                     <Phone size={20} className="mr-2" />
//                     Contact
//                   </h3>
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                     <div>
//                       <label className="block text-sm font-bold text-gray-700 mb-2">Email *</label>
//                       <input
//                         type="email"
//                         name="email"
//                         value={formData.email}
//                         onChange={handleInputChange}
//                         className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500"
//                         placeholder="email@example.com"
//                       />
//                     </div>

//                     <div>
//                       <label className="block text-sm font-bold text-gray-700 mb-2">Téléphone *</label>
//                       <input
//                         type="tel"
//                         name="phone"
//                         value={formData.phone}
//                         onChange={handleInputChange}
//                         className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500"
//                         placeholder="+221 77 123 45 67"
//                       />
//                     </div>
//                   </div>

//                   <div className="mt-4">
//                     <label className="block text-sm font-bold text-gray-700 mb-2">Adresse *</label>
//                     <input
//                       type="text"
//                       name="address"
//                       value={formData.address}
//                       onChange={handleInputChange}
//                       className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500"
//                       placeholder="Adresse complète"
//                     />
//                   </div>
//                 </div>

//                 {/* Employment Info */}
//                 <div>
//                   <h3 className="font-bold text-gray-800 mb-4 flex items-center">
//                     <Calendar size={20} className="mr-2" />
//                     Informations d'embauche
//                   </h3>
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                     <div>
//                       <label className="block text-sm font-bold text-gray-700 mb-2">Date d'embauche *</label>
//                       <input
//                         type="date"
//                         name="hireDate"
//                         value={formData.hireDate}
//                         onChange={handleInputChange}
//                         className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500"
//                       />
//                     </div>

//                     <div>
//                       <label className="block text-sm font-bold text-gray-700 mb-2">Statut</label>
//                       <select
//                         name="status"
//                         value={formData.status}
//                         onChange={handleInputChange}
//                         className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500"
//                       >
//                         <option value="active">Actif</option>
//                         <option value="inactive">Inactif</option>
//                       </select>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Account Security */}
//                 <div>
//                   <h3 className="font-bold text-gray-800 mb-4 flex items-center">
//                     <Shield size={20} className="mr-2" />
//                     Sécurité du compte
//                   </h3>
//                   <div>
//                     <label className="block text-sm font-bold text-gray-700 mb-2">
//                       Mot de passe {!showEditModal && '*'}
//                     </label>
//                     <div className="relative">
//                       <input
//                         type={showPassword ? 'text' : 'password'}
//                         name="password"
//                         value={formData.password}
//                         onChange={handleInputChange}
//                         className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500"
//                         placeholder={showEditModal ? 'Laisser vide pour ne pas modifier' : 'Mot de passe'}
//                       />
//                       <button
//                         type="button"
//                         onClick={() => setShowPassword(!showPassword)}
//                         className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"
//                       >
//                         {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Actions */}
//               <div className="flex space-x-3 pt-6 border-t border-gray-200 mt-6">
//                 <button
//                   onClick={closeModals}
//                   className="flex-1 px-6 py-3 bg-gray-100 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-200 transition-all font-bold"
//                 >
//                   Annuler
//                 </button>
//                 <button
//                   onClick={handleSubmit}
//                   className="flex-1 px-6 py-3 bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded-xl hover:shadow-xl transition-all font-bold"
//                 >
//                   <Save size={20} className="inline mr-2" />
//                   {showEditModal ? 'Mettre à jour' : 'Créer'}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default VendorManagement;



import React, { useState } from 'react';
import { UserPlus, Users, Mail, Phone, Shield, Plus, Edit, Trash2, Search, X, Save, Eye, EyeOff, ShoppingBag, IdCard, Calendar } from 'lucide-react';

const VendorManagementSobre = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    cin: '',
    address: '',
    birthDate: '',
    hireDate: '',
    password: '',
    status: 'active'
  });

  const vendors = [
    {
      id: 1,
      firstName: 'Moussa',
      lastName: 'Sow',
      email: 'm.sow@pharmacie.sn',
      phone: '+221 77 111 22 33',
      cin: '2845 1998 12345',
      address: 'Liberté 6, Dakar',
      birthDate: '1998-05-15',
      hireDate: '2023-01-15',
      status: 'active',
      createdAt: '2023-01-15'
    },
    {
      id: 2,
      firstName: 'Awa',
      lastName: 'Diallo',
      email: 'a.diallo@pharmacie.sn',
      phone: '+221 77 222 33 44',
      cin: '1923 1995 67890',
      address: 'Médina, Dakar',
      birthDate: '1995-08-20',
      hireDate: '2023-03-01',
      status: 'active',
      createdAt: '2023-03-01'
    },
    {
      id: 3,
      firstName: 'Ibrahima',
      lastName: 'Niang',
      email: 'i.niang@pharmacie.sn',
      phone: '+221 77 333 44 55',
      cin: '1567 1997 11111',
      address: 'Grand Yoff, Dakar',
      birthDate: '1997-12-10',
      hireDate: '2023-06-15',
      status: 'inactive',
      createdAt: '2023-06-15'
    },
    {
      id: 4,
      firstName: 'Fatou',
      lastName: 'Cissé',
      email: 'f.cisse@pharmacie.sn',
      phone: '+221 77 444 55 66',
      cin: '2234 1999 22222',
      address: 'Parcelles Assainies, Dakar',
      birthDate: '1999-03-25',
      hireDate: '2024-01-10',
      status: 'active',
      createdAt: '2024-01-10'
    }
  ];

  const filteredVendors = vendors.filter(vendor =>
    vendor.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    vendor.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    vendor.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    vendor.phone.includes(searchTerm) ||
    vendor.cin.includes(searchTerm)
  );

  const stats = {
    total: vendors.length,
    active: vendors.filter(v => v.status === 'active').length,
    inactive: vendors.filter(v => v.status === 'inactive').length
  };

  const getStatusBadge = (status) => {
    return status === 'active'
      ? { bg: 'bg-green-50', text: 'text-green-700', label: 'Actif', border: 'border-green-200' }
      : { bg: 'bg-gray-100', text: 'text-gray-700', label: 'Inactif', border: 'border-gray-300' };
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const openAddModal = () => {
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      cin: '',
      address: '',
      birthDate: '',
      hireDate: new Date().toISOString().split('T')[0],
      password: '',
      status: 'active'
    });
    setShowAddModal(true);
  };

  const openEditModal = (vendor) => {
    setSelectedVendor(vendor);
    setFormData({
      firstName: vendor.firstName,
      lastName: vendor.lastName,
      email: vendor.email,
      phone: vendor.phone,
      cin: vendor.cin,
      address: vendor.address,
      birthDate: vendor.birthDate,
      hireDate: vendor.hireDate,
      password: '',
      status: vendor.status
    });
    setShowEditModal(true);
  };

  const closeModals = () => {
    setShowAddModal(false);
    setShowEditModal(false);
    setSelectedVendor(null);
    setShowPassword(false);
  };

  const handleSubmit = () => {
    alert(showEditModal ? 'Vendeur modifié !' : 'Vendeur créé !');
    closeModals();
  };

  const handleDelete = (id) => {
    if (window.confirm('Supprimer ce vendeur ?')) {
      alert('Vendeur supprimé !');
    }
  };

  const toggleStatus = (vendor) => {
    const newStatus = vendor.status === 'active' ? 'inactive' : 'active';
    if (window.confirm(`${newStatus === 'active' ? 'Activer' : 'Désactiver'} ce vendeur ?`)) {
      alert(`Vendeur ${newStatus === 'active' ? 'activé' : 'désactivé'} !`);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR', { 
      day: '2-digit', 
      month: 'long', 
      year: 'numeric' 
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="p-6">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6 border border-gray-200">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center">
              <Users className="text-white" size={24} />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Gestion des Vendeurs</h1>
              <p className="text-gray-600 text-sm">Créez et gérez les comptes de vos vendeurs</p>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">Total vendeurs</p>
                <p className="text-3xl font-bold text-gray-900">{stats.total}</p>
              </div>
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                <Users className="text-green-600" size={24} />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">Actifs</p>
                <p className="text-3xl font-bold text-green-600">{stats.active}</p>
              </div>
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                <ShoppingBag className="text-green-600" size={24} />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">Inactifs</p>
                <p className="text-3xl font-bold text-gray-600">{stats.inactive}</p>
              </div>
              <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
                <Users className="text-gray-600" size={24} />
              </div>
            </div>
          </div>
        </div>

        {/* Search and Add */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6 border border-gray-200">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1">
              <div className="relative">
                <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                <input
                  type="text"
                  placeholder="Rechercher un vendeur (nom, email, téléphone, CIN)..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                />
              </div>
            </div>
            <button
              onClick={openAddModal}
              className="flex items-center space-x-2 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-all font-medium whitespace-nowrap"
            >
              <Plus size={20} />
              <span>Nouveau vendeur</span>
            </button>
          </div>
        </div>

        {/* Vendors Table */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-900 flex items-center">
              <Users size={20} className="mr-2" />
              Liste des Vendeurs ({filteredVendors.length})
            </h2>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200">
                  <th className="px-6 py-3 text-left">
                    <span className="text-xs font-semibold text-gray-600 uppercase">Vendeur</span>
                  </th>
                  <th className="px-6 py-3 text-left">
                    <span className="text-xs font-semibold text-gray-600 uppercase">Contact</span>
                  </th>
                  <th className="px-6 py-3 text-left">
                    <span className="text-xs font-semibold text-gray-600 uppercase">CIN</span>
                  </th>
                  <th className="px-6 py-3 text-left">
                    <span className="text-xs font-semibold text-gray-600 uppercase">Date embauche</span>
                  </th>
                  <th className="px-6 py-3 text-center">
                    <span className="text-xs font-semibold text-gray-600 uppercase">Statut</span>
                  </th>
                  <th className="px-6 py-3 text-right">
                    <span className="text-xs font-semibold text-gray-600 uppercase">Actions</span>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {filteredVendors.map((vendor) => {
                  const statusBadge = getStatusBadge(vendor.status);

                  return (
                    <tr key={vendor.id} className="hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4">
                        <div className="flex items-center space-x-3">
                          <div className="w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center text-white font-bold flex-shrink-0">
                            {vendor.firstName.charAt(0)}{vendor.lastName.charAt(0)}
                          </div>
                          <div>
                            <p className="font-semibold text-gray-900">
                              {vendor.firstName} {vendor.lastName}
                            </p>
                            <p className="text-xs text-gray-500">Vendeur</p>
                          </div>
                        </div>
                      </td>

                      <td className="px-6 py-4">
                        <div className="space-y-1">
                          <a 
                            href={`mailto:${vendor.email}`} 
                            className="flex items-center space-x-2 text-sm text-gray-700 hover:text-green-600 transition-colors"
                          >
                            <Mail size={14} className="text-gray-400" />
                            <span className="truncate max-w-xs">{vendor.email}</span>
                          </a>
                          <a 
                            href={`tel:${vendor.phone}`} 
                            className="flex items-center space-x-2 text-sm text-gray-700 hover:text-green-600 transition-colors"
                          >
                            <Phone size={14} className="text-gray-400" />
                            <span>{vendor.phone}</span>
                          </a>
                        </div>
                      </td>

                      <td className="px-6 py-4">
                        <div className="flex items-center space-x-2">
                          <IdCard size={14} className="text-gray-400" />
                          <span className="text-sm font-mono text-gray-700">{vendor.cin}</span>
                        </div>
                      </td>

                      <td className="px-6 py-4">
                        <div className="flex items-center space-x-2">
                          <Calendar size={14} className="text-gray-400" />
                          <span className="text-sm text-gray-700">{formatDate(vendor.hireDate)}</span>
                        </div>
                      </td>

                      <td className="px-6 py-4">
                        <div className="flex justify-center">
                          <span className={`px-3 py-1 ${statusBadge.bg} ${statusBadge.text} rounded-full text-xs font-medium border ${statusBadge.border}`}>
                            {statusBadge.label}
                          </span>
                        </div>
                      </td>

                      <td className="px-6 py-4">
                        <div className="flex items-center justify-end space-x-2">
                          <button
                            onClick={() => openEditModal(vendor)}
                            className="p-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-all"
                            title="Modifier"
                          >
                            <Edit size={16} />
                          </button>
                          
                          <button
                            onClick={() => toggleStatus(vendor)}
                            className={`p-2 rounded-lg transition-all ${
                              vendor.status === 'active'
                                ? 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                : 'bg-green-50 text-green-600 hover:bg-green-100'
                            }`}
                            title={vendor.status === 'active' ? 'Désactiver' : 'Activer'}
                          >
                            {vendor.status === 'active' ? (
                              <EyeOff size={16} />
                            ) : (
                              <Eye size={16} />
                            )}
                          </button>

                          <button
                            onClick={() => handleDelete(vendor.id)}
                            className="p-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition-all"
                            title="Supprimer"
                          >
                            <Trash2 size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {filteredVendors.length === 0 && (
            <div className="text-center py-12">
              <Users size={48} className="mx-auto text-gray-300 mb-4" />
              <p className="text-gray-500 font-medium">Aucun vendeur trouvé</p>
              <p className="text-gray-400 text-sm mt-2">Essayez de modifier votre recherche</p>
            </div>
          )}
        </div>
      </main>

      {/* Add/Edit Modal */}
      {(showAddModal || showEditModal) && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-green-600 px-6 py-4 flex items-center justify-between z-10">
              <h2 className="text-xl font-bold text-white">
                {showEditModal ? 'Modifier le vendeur' : 'Nouveau vendeur'}
              </h2>
              <button onClick={closeModals} className="p-2 hover:bg-green-700 rounded-lg transition-all text-white">
                <X size={24} />
              </button>
            </div>

            <div className="p-6">
              <div className="space-y-6">
                {/* Personal Info */}
                <div>
                  <h3 className="font-semibold text-gray-900 mb-4 flex items-center">
                    <Users size={18} className="mr-2" />
                    Informations personnelles
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Prénom *</label>
                      <input
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                        placeholder="Prénom"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Nom *</label>
                      <input
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                        placeholder="Nom"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Date de naissance *</label>
                      <input
                        type="date"
                        name="birthDate"
                        value={formData.birthDate}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">CIN *</label>
                      <input
                        type="text"
                        name="cin"
                        value={formData.cin}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                        placeholder="1234 1990 12345"
                      />
                    </div>
                  </div>
                </div>

                {/* Contact Info */}
                <div>
                  <h3 className="font-semibold text-gray-900 mb-4 flex items-center">
                    <Phone size={18} className="mr-2" />
                    Contact
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Email *</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                        placeholder="email@example.com"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Téléphone *</label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                        placeholder="+221 77 123 45 67"
                      />
                    </div>
                  </div>

                  <div className="mt-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Adresse *</label>
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                      placeholder="Adresse complète"
                    />
                  </div>
                </div>

                {/* Employment Info */}
                <div>
                  <h3 className="font-semibold text-gray-900 mb-4 flex items-center">
                    <Calendar size={18} className="mr-2" />
                    Informations d'embauche
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Date d'embauche *</label>
                      <input
                        type="date"
                        name="hireDate"
                        value={formData.hireDate}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Statut</label>
                      <select
                        name="status"
                        value={formData.status}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                      >
                        <option value="active">Actif</option>
                        <option value="inactive">Inactif</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Account Security */}
                <div>
                  <h3 className="font-semibold text-gray-900 mb-4 flex items-center">
                    <Shield size={18} className="mr-2" />
                    Sécurité du compte
                  </h3>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Mot de passe {!showEditModal && '*'}
                    </label>
                    <div className="relative">
                      <input
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                        placeholder={showEditModal ? 'Laisser vide pour ne pas modifier' : 'Mot de passe'}
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                      >
                        {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Actions */}
              <div className="flex space-x-3 pt-6 border-t border-gray-200 mt-6">
                <button
                  onClick={closeModals}
                  className="flex-1 px-6 py-3 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-all font-medium"
                >
                  Annuler
                </button>
                <button
                  onClick={handleSubmit}
                  className="flex-1 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-all font-medium"
                >
                  <Save size={20} className="inline mr-2" />
                  {showEditModal ? 'Mettre à jour' : 'Créer'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VendorManagementSobre;